import { render, staticRenderFns } from "./BasicPersonalInfo.vue?vue&type=template&id=69b5f326&scoped=true"
import script from "./BasicPersonalInfo.vue?vue&type=script&lang=js"
export * from "./BasicPersonalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b5f326",
  null
  
)

export default component.exports